<div class="modal-header">
  <h5 class="modal-title">Image Analyzer</h5>
  <button type="button" class="btn-close btn-close-white" (click)="close()" aria-label="Close"></button>
</div>
<div class="modal-body">
  <h4>Select Screenshots</h4>
  <p>
    Provide screenshots of the car settings from GT7. Match the screenshots with the correct slot based on the instructions below.
    It is not required to provide an image for every slot. The analyzer will extract the parameters from the givine screenshots.
    Use the Playstation screenshot tools to capture the image. Do not crop the images.
    For proper processing, use the d-pad to navigate to the ECU settings.
  </p>

  <p>
    <a href="#" (click)="!howToScreenshotCollapsed=!howToScreenshotCollapsed"
       [attr.aria-expanded]="howToScreenshotCollapsed">
      <i class="fa-solid fa-circle-question"></i> How to get screenshots
    </a>
  </p>

  <div class="mb-2" #howToScreenshot="ngbCollapse" [(ngbCollapse)]="howToScreenshotCollapsed">
    <ol>
      <li>Go to car settings.</li>
      <li>
        Take a screenshot of the first page of settings.
        <a href="/assets/images/screenshot-example-1.jpg" target="_blank">Slot 1 example <sup class="fa-solid fa-arrow-up-right-from-square"></sup></a>
      </li>
      <li>Press the "Share" button on the playstation controller.</li>
      <li>
        Open the ECU settings in car settings to display the dyno graph.
        <a href="/assets/images/screenshot-example-2.jpg" target="_blank">Slot 2 example <sup class="fa-solid fa-arrow-up-right-from-square"></sup></a>
      </li>
      <li>Press the "Share" button on the playstation controller.</li>
      <li>
        Open the Transmission Manual Adjustment window.
        <a href="/assets/images/screenshot-example-3.jpg" target="_blank">Slot 3 example <sup class="fa-solid fa-arrow-up-right-from-square"></sup></a>
      </li>
      <li>Press the "Share" button on the playstation controller.</li>
      <li>In the Playstation 5 Media Library, highlight the screenshot and press the "Options" button.</li>
      <li>Select "Upload to Playstation App".</li>
      <li>Download the screenshot using the PS app on your mobile device.</li>
      <li>In the Playstation 4 Media Library, select the screenshot and choose to copy to USB. You will need to plug in a USB storage device.</li>
      <li>Alternatively, you can share screenshots to your social media or send it to yourself in a message.</li>
    </ol>
  </div>
  <p>
    <a href="#" (click)="!howToSelectCollapsed=!howToSelectCollapsed"
       [attr.aria-expanded]="howToSelectCollapsed">
      <i class="fa-solid fa-circle-question"></i> How to select screenshots
    </a>
  </p>

  <div class="mb-2" #howToSelect="ngbCollapse" [(ngbCollapse)]="howToSelectCollapsed">
    <ol>
      <li>In the GT Pro Analyze Image window, click the "Select Screenshot" <i class="fa-regular fa-solid fa-image"></i> button</li>
      <li>
        Select the screenshot for the appropriate slot.
        <ul>
          <li>Slot 1: First page from car settings <a href="/assets/images/screenshot-example-1.jpg" target="_blank">Slot 1 example <sup class="fa-solid fa-arrow-up-right-from-square"></sup></a></li>
          <li>Slot 2: ECU graph <a href="/assets/images/screenshot-example-2.jpg" target="_blank">Slot 2 example <sup class="fa-solid fa-arrow-up-right-from-square"></sup></a></li>
          <li>Slot 3: Transmission Manual Adjustment window <a href="/assets/images/screenshot-example-3.jpg" target="_blank">Slot 3 example <sup class="fa-solid fa-arrow-up-right-from-square"></sup></a></li>
        </ul>
      </li>
      <li>Click Analyze.</li>
    </ol>
  </div>

  <p>Note: At least 1 screenshot is required. For best results, provide a screenshot for each slot.  Images are not stored in GT Pro Tune. </p>

  <div class="row mb-3 text-center">
    <div class="col-12 col-lg-4 mb-3">
      <h5>Slot 1 - Basic Settings</h5>
      <app-image-selector [customClass]="'slot1-selector'" [(imageFile)]="screenshot1File"></app-image-selector>
    </div>

    <div class="col-12 col-lg-4 mb-3">
      <h5>Slot 2 - ECU Graph</h5>
      <app-image-selector [customClass]="'slot2-selector'" [(imageFile)]="screenshot2File"></app-image-selector>
    </div>

    <div class="col-12 col-lg-4 mb-3">
      <h5>Slot 3 - Transmission</h5>
      <app-image-selector [customClass]="'slot3-selector'" [(imageFile)]="screenshot3File"></app-image-selector>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <button type="button" class="btn btn-primary analyze-button" (click)="analyzeImages()" [disabled]="loading">
        @if (!showResults && loading){
        <i class="fa-solid fa-spinner fa-spin"></i>
        }
        @else{
        <i class="fa-solid fa-square-binary"></i>
        } Analyze
      </button>
    </div>
  </div>



  @if (showResults){
  <hr />

  <h4>Image Analysis Results</h4>
  <p>
    Review the results of the image analysis. You can change any incorrect values before continuing or choose only to accept car settings parameters or engine data. If you continue, the values shown below will
    be used to auto-fill settings.
  </p>
  }

  <form #analyzedDataForm="ngForm" [hidden]="!showResults">
    <div class="row text-primary">
      <div class="col"><hr /></div>
      <div class="col-auto">
        <label>
          <input type="checkbox" class="form-check-input" #acceptParameters name="acceptParameters" [(ngModel)]="acceptParameters" />
          Car Settings Parameters
        </label>
      </div>
      <div class="col"><hr /></div>
    </div>

    @if (acceptParameters){
    <div class="row">
      <div class="col-6">
        <app-vehicle-selector [(model)]="analyzedData.vehicle"></app-vehicle-selector>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <div class="form-group row mb-3">
          <div class="col">
            <label for="performancePoints" class="form-label">Performance Points</label>
            <input type="number" class="form-control  w-120px" #performancePoints name="performancePoints" placeholder="PP" [(ngModel)]="analyzedData.performancePoints">
          </div>
        </div>

        <div class="form-group row mb-3">
          <div class="col">
            <label for="weight" class="form-label">Weight</label>
            <input type="number" class="form-control  w-120px" #weight name="weight" placeholder="Weight" [(ngModel)]="analyzedData.weight">
          </div>
        </div>

        <div class="form-group row mb-3">
          <div class="col">
            <label for="frontTires" class="form-label">Front Tires</label>
            <select class="form-select  w-200px" #frontTires name="frontTires" [(ngModel)]="analyzedData.frontTires">
              <option></option>
              <option value="-4">Comfort: Hard</option>
              <option value="-3">Comfort: Medium</option>
              <option value="-2">Comfort: Soft</option>
              <option value="-1">Sport: Hard</option>
              <option value="0">Sport: Medium</option>
              <option value="1">Sport: Soft</option>
              <option value="2">Racing: Hard</option>
              <option value="3">Racing: Medium</option>
              <option value="4">Racing: Soft</option>
            </select>
          </div>
        </div>

        <div class="form-group row mb-3">
          <div class="col">
            <label for="rearTires" class="form-label">Rear Tires</label>
            <select class="form-select  w-200px" #rearTires name="frontTires" [(ngModel)]="analyzedData.rearTires">
              <option></option>
              <option value="-4">Comfort: Hard</option>
              <option value="-3">Comfort: Medium</option>
              <option value="-2">Comfort: Soft</option>
              <option value="-1">Sport: Hard</option>
              <option value="0">Sport: Medium</option>
              <option value="1">Sport: Soft</option>
              <option value="2">Racing: Hard</option>
              <option value="3">Racing: Medium</option>
              <option value="4">Racing: Soft</option>
            </select>
          </div>
        </div>

        <div class="form-group row mb-3">
          <div class="col">
            <label for="wheelSize" class="form-label">WheelSize</label>
            <input type="number" class="form-control  w-120px" #wheelSize name="wheelSize" placeholder="Wheel Size" [(ngModel)]="analyzedData.wheelSize">
          </div>
        </div>

        <div class="form-group row mb-3">
          <div class="col">
            <label for="frontRearWeightBalance" class="form-label">Front-Rear Weight Balance</label>
            <div class="input-group  w-200px">
              <input type="number" class="form-control " id="weightDistributionPercent" name="weightDistributionPercent" placeholder="front %" [(ngModel)]="analyzedData.weightDistributionPercent">
              <div class="input-group-text bg-dark-gold text-primary">%</div>
            </div>
          </div>
        </div>

        <div class="form-group row mb-3" [ngClass]="{'invalid': analyzedDataFormControl.lowSpeedStability?.errors && analyzedDataFormControl.lowSpeedStability?.touched}">
          <div class="col">
            <label for="lowSpeedStability" class="form-label">Low Speed</label>
            <input type="text" pattern="\-?[0-9]*[\.,]?[0-9]*" class="form-control   w-120px" #lowSpeedStability name="lowSpeedStability" placeholder="(under)" [(ngModel)]="analyzedData.lowSpeed">
          </div>
        </div>

        <div class="form-group row mb-3" [ngClass]="{'invalid': analyzedDataFormControl.highSpeedStability?.errors && analyzedDataFormControl.highSpeedStability?.touched}">
          <div class="col">
            <label for="highSpeedStability" class="form-label">High Speed</label>
            <input type="text" pattern="\-?[0-9]*[\.,]?[0-9]*" class="form-control   w-120px" #highSpeedStability name="highSpeedStability" placeholder="(under)" [(ngModel)]="analyzedData.highSpeed">
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group row mb-3" [ngClass]="{'invalid': analyzedDataFormControl.rotationalG1?.errors && analyzedDataFormControl.rotationalG1?.touched}">
          <div class="col">
            <label for="rotationalG1" class="form-label">G 40mph</label>
            <div class="input-group  w-200px">
              <input type="number" class="form-control " id="rotationalG1" name="rotationalG1" placeholder="G" [(ngModel)]="analyzedData.rotationalG1">
              <div class="input-group-text bg-dark-gold text-primary">G</div>
            </div>
          </div>
        </div>

        <div class="form-group row mb-3" [ngClass]="{'invalid': analyzedDataFormControl.rotationalG2?.errors && analyzedDataFormControl.rotationalG2?.touched}">
          <div class="col">
            <label for="rotationalG2" class="form-label">75 mph</label>
            <div class="input-group  w-200px">
              <input type="number" class="form-control " id="rotationalG2" name="rotationalG2" placeholder="G" [(ngModel)]="analyzedData.rotationalG2">
              <div class="input-group-text bg-dark-gold text-primary">G</div>
            </div>
          </div>
        </div>

        <div class="form-group row mb-3" [ngClass]="{'invalid': analyzedDataFormControl.rotationalG3?.errors && analyzedDataFormControl.rotationalG3?.touched}">
          <div class="col-6">
            <label for="rotaionalG3" class="form-label">150 mph</label>

            <div class="input-group  w-200px">
              <input type="number" class="form-control " id="rotationalG3" name="rotationalG3" placeholder="G" [(ngModel)]="analyzedData.rotationalG3">
              <div class="input-group-text bg-dark-gold text-primary">G</div>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12">
            <label class="form-label">Body Height</label>
            <div class="row">
              <div class="w-120px me-2 text-center">
                Front
              </div>
              <div class="w-120px text-center">
                Rear
              </div>
            </div>
            <div class="row">
              <div class="w-120px me-2">
                <input type="number" class="form-control  w-120px" id="bodyHeightFront" name="bodyHeightFront" placeholder="Body Height Front" [(ngModel)]="analyzedData.bodyHeightFront">
              </div>
              <div class="w-120px">
                <input type="number" class="form-control  w-120px" id="bodyHeightRear" name="bodyHeightRear" placeholder="Body Height Rear" [(ngModel)]="analyzedData.bodyHeightRear">
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12">
            <label class="form-label">Downforce</label>
            <div class="row">
              <div class="w-120px me-2 text-center">
                Front
              </div>
              <div class="w-120px text-center">
                Rear
              </div>
            </div>
            <div class="row">
              <div class="w-120px me-2">
                <input type="number" class="form-control  w-120px" id="downforceFront" name="downforceFront" placeholder="Downforce Front" [(ngModel)]="analyzedData.downforceFront">
              </div>
              <div class="w-120px">
                <input type="number" class="form-control  w-120px" id="downforceRear" name="downforceRear" placeholder="Downforce Rear" [(ngModel)]="analyzedData.downforceRear">
              </div>
            </div>
          </div>
        </div>

        <div class="form-group row mb-3" [ngClass]="{'invalid': analyzedDataFormControl.maxPower?.errors && analyzedDataFormControl.maxPower?.touched}">
          <div class="col">
            <label for="maxPower" class="form-label">Max Power</label>
            <input type="number" class="form-control  w-120px" id="maxPower" name="maxPower" placeholder="Power" [(ngModel)]="analyzedData.maxPower">
          </div>
        </div>

        <div class="form-group row mb-3" [ngClass]="{'invalid': analyzedDataFormControl.minRPM?.errors && analyzedDataFormControl.minRPM?.touched}">
          <div class="col">
            <label for="minRPM" class="form-label">Min RPM</label>
            <input type="number" class="form-control  w-120px" id="minRPM" name="minRPM" placeholder="RPM" [(ngModel)]="analyzedData.minRPM">
          </div>
        </div>

        <div class="form-group row mb-3" [ngClass]="{'invalid': analyzedDataFormControl.maxRPM?.errors && analyzedDataFormControl.maxRPM?.touched}">
          <div class="col">
            <label for="maxRPM" class="form-label">Max RPM</label>
            <input type="number" class="form-control  w-120px" id="maxRPM" name="maxRPM" placeholder="RPM" [(ngModel)]="analyzedData.maxRPM">
          </div>
        </div>

        <div class="form-group row mb-3" [ngClass]="{'invalid': analyzedDataFormControl.maxTorque?.errors && analyzedDataFormControl.maxTorque?.touched}">
          <div class="col">
            <label for="maxTorque" class="form-label">Max Torque</label>
            <input type="number" class="form-control  w-120px" id="maxTorque" name="maxTorque" placeholder="Torque" [(ngModel)]="analyzedData.maxTorque">
          </div>
        </div>
      </div>
    </div>
    }
    @else{
    <p>Exclude Car Settings Parameters</p>
    }
  </form>

  @if (showResults && analyzedData.engineData?.length > 0){
  <div class="row text-primary">
    <div class="col"><hr /></div>
    <div class="col-auto">
      <label>
        <input type="checkbox" class="form-check-input" #acceptEngineData name="acceptEngineData" [(ngModel)]="acceptEngineData" />
        Engine Data
      </label>
    </div>
    <div class="col"><hr /></div>
  </div>
  }
  @if (acceptEngineData && dynoChartConfig && analyzedData.engineData?.length > 0){
  <div class="row">
    <div class="col-12 col-lg-6 mb-3 h-300px" [hidden]="!dynoChartConfig">
      <canvas id="dynoChart" class="bg-light" appChartJs chartId="dynoChart" [chartConfig]="dynoChartConfig"></canvas>
    </div>
    <div class="col-12 col-lg-6 mb-3">
      <table class="table table-sm">
        <thead>
          <tr>
            <th>RPM</th>
            <th>Torque</th>
            <th>Power</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let ed of analyzedData.engineData">
            <td>{{ed.rpm}}</td>
            <td>{{ed.torque | lbftToTorque: torqueUnits  }}</td>
            <td>{{ed.power | hpToPower: powerUnits  }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  }
  @else if(showResults && analyzedData.engineData?.length > 0) {
  <p>Exclude Engine Data</p>
  }

</div>
<div class="modal-footer">
  <app-image-analyzer-tour class="me-auto"></app-image-analyzer-tour>
  <button type="button" class="btn btn-outline-primary" (click)="close()">Cancel</button>
  <button type="button" class="btn btn-primary" (click)="ok()" [disabled]="!showResults || loading">Ok</button>
</div>

